import { CampaignFlowType } from './campaign-contract';

export interface CampaignLoginSignals {
  authenticated: boolean;
  fixaSession: boolean;
  resources?: unknown;
}

export function campaignLoginType(session: CampaignLoginSignals): CampaignFlowType | null {
  if (!session.authenticated) {
    return null;
  }

  if (session.fixaSession) {
    return 'FIXA';
  }

  if (isMobileResources(session.resources)) {
    return 'MOVEL';
  }

  return 'PROSPECT';
}

function isMobileResources(resources: unknown): boolean {
  return (
    Array.isArray(resources) &&
    resources.length > 0 &&
    resources.every(item => typeof item === 'string' && item.length > 0)
  );
}
